export enum EParentesco {
    IrmaoIrma,
    EsposoEsposa,
    FilhoFilha,
    Pai,
    Mae,
    Avo,
    TioTia,
    PrimoPrima,
    SobrinhoSobrinha,
    NetoNeta,
    AmigoAmiga,
    NamoradoNamorada,
    Ouros,

}

export const EParentescoLabel = new Map<string, string>([
    ['IrmaoIrma', "Irmão/Irmã"],
    ['EsposoEsposa', "Esposo(a)"],
    ['FilhoFilha', "Filho(a)"],
    ['Pai', "Pai"],
    ['Mae', "Mãe"],
    ['Avo', "Avô/Avó"],
    ['TioTia', "Tio(a)"],
    ['PrimoPrima', "Primo(a)"],
    ['SobrinhoSobrinha', "Sobrinho(a)"],
    ['NetoNeta', "Neto(a)"],
    ['AmigoAmiga', "Amigo(a)"],
    ['NamoradoNamorada', "Namorado(a)"],
    ['Ouros', "Outros"]  
]);


export const ParentescoArray = [
    {
        value:EParentesco[0],
        descricao:EParentescoLabel.get(EParentesco[0])
    },
    {
        value:EParentesco[1],
        descricao:EParentescoLabel.get(EParentesco[1])
    },
    {
        value:EParentesco[2],
        descricao:EParentescoLabel.get(EParentesco[2])
    },
    {
        value:EParentesco[3],
        descricao:EParentescoLabel.get(EParentesco[3])
    },
    {
        value:EParentesco[4],
        descricao:EParentescoLabel.get(EParentesco[4])
    },
    {
        value:EParentesco[5],
        descricao:EParentescoLabel.get(EParentesco[5])
    },
    {
        value:EParentesco[6],
        descricao:EParentescoLabel.get(EParentesco[6])
    },
    {
        value:EParentesco[7],
        descricao:EParentescoLabel.get(EParentesco[7])
    },
    {
        value:EParentesco[8],
        descricao:EParentescoLabel.get(EParentesco[8])
    },
    {
        value:EParentesco[9],
        descricao:EParentescoLabel.get(EParentesco[9])
    },
    {
        value:EParentesco[10],
        descricao:EParentescoLabel.get(EParentesco[10])
    },
    {
        value:EParentesco[11],
        descricao:EParentescoLabel.get(EParentesco[11])
    },


]